import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('history');

export const check = () => useBasicAuth.checkToken();

export const findAllHistory = () => 
  axios.get(urlAPI + "/findAll" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
});

export const findAllHistoryByUser = (id) => 
  axios.get(urlAPI + "/user/" + id , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
});
